export const customerEvents = Object.freeze({
  label: 'Customer Events',
  description: 'Send all customer subscribes and unsubscribes',
  items: [
    {
      label: 'Subscribed',
      value: 'customer_subscribed',
      description: "A person's subscription status has changed to subscribed",
    },
    {
      label: 'Unsubscribed',
      value: 'customer_unsubscribed',
      description: "A person's subscription status has changed to unsubscribed",
    },
    {
      label: 'Subscription preferences changed',
      value: 'customer_subscription_preferences_changed',
      description: "A person's subscription preferences have changed",
    },
  ],
});
export const emailEvents = Object.freeze({
  label: 'Email Events',
  description: 'Send all Email events',
  items: [
    {
      label: 'Drafted',
      value: 'email_drafted',
      description: 'An email draft was created',
    },
    {
      label: 'Attempted',
      value: 'email_attempted',
      description: "An email that couldn't be sent to the delivery provider will be retried",
    },
    {
      label: 'Deferred',
      value: 'email_deferred',
      description: "An email that the delivery provider couldn't send will be retried by the delivery provider",
    },
    {
      label: 'Sent',
      value: 'email_sent',
      description: 'An email was sent from Customer.io to the delivery provider',
    },
    {
      label: 'Delivered',
      value: 'email_delivered',
      description: 'The delivery provider reported the email was delivered to an inbox',
    },
    {
      label: 'Opened',
      value: 'email_opened',
      description: 'An email was opened',
    },
    {
      label: 'Clicked',
      value: 'email_clicked',
      description: 'A tracked link in an email was clicked',
    },
    {
      label: 'Converted',
      value: 'email_converted',
      description: 'A person matched a conversion goal attributed to an email',
    },
    {
      label: 'Unsubscribed',
      value: 'email_unsubscribed',
      description: 'A person unsubscribed via a particular email',
    },
    {
      label: 'Bounced',
      value: 'email_bounced',
      description: 'The delivery provider was unable to deliver the email',
    },
    {
      label: 'Suppressed',
      value: 'email_dropped',
      description: "An email wasn't sent because it was addressed to a person who was suppressed",
    },
    {
      label: 'Spammed',
      value: 'email_spammed',
      description: 'An email was marked as spam by the recipient',
    },
    {
      label: 'Failed',
      value: 'email_failed',
      description: "An email couldn't be sent to the delivery provider",
    },
    {
      label: 'Undeliverable',
      value: 'email_undeliverable',
      description: 'An email was marked as undeliverable',
    },
  ],
});
export const inAppEvents = Object.freeze({
  label: 'In-App Events',
  description: 'Send all in-app events',
  items: [
    {
      label: 'Drafted',
      value: 'in_app_drafted',
      description: 'An in-app message draft was created',
    },
    {
      label: 'Attempted',
      value: 'in_app_attempted',
      description: "An in-app message that couldn't be sent will be retried",
    },
    {
      label: 'Sent',
      value: 'in_app_sent',
      description:
        'An in-app message was sent from Customer.io and is ready for the person to view on their next visit',
    },
    {
      label: 'Opened',
      value: 'in_app_opened',
      description: 'An in-app message was viewed',
    },
    {
      label: 'Clicked',
      value: 'in_app_clicked',
      description: 'A tracked action in an in-app message was clicked',
    },
    {
      label: 'Converted',
      value: 'in_app_converted',
      description: 'A person matched a conversion goal attributed to an in-app message',
    },
    {
      label: 'Failed',
      value: 'in_app_failed',
      description: 'An in-app message failed to send',
    },
    {
      label: 'Undeliverable',
      value: 'in_app_undeliverable',
      description: 'An in-app message was marked as undeliverable',
    },
  ],
});
export const pushEvents = Object.freeze({
  label: 'Push Events',
  description: 'Send all Push events',
  items: [
    {
      label: 'Drafted',
      value: 'push_drafted',
      description: 'A push notification draft was created',
    },
    {
      label: 'Attempted',
      value: 'push_attempted',
      description: "A push notification that couldn't be sent to the delivery provider will be retried",
    },
    {
      label: 'Sent',
      value: 'push_sent',
      description: 'A push notification was sent from Customer.io to the delivery provider',
    },
    {
      label: 'Delivered',
      value: 'push_delivered',
      description: "The app on a person's device reported the push notification was delivered",
    },
    {
      label: 'Opened',
      value: 'push_opened',
      description: "The app on a person's device reported the push notification was opened",
    },
    {
      label: 'Clicked',
      value: 'push_clicked',
      description: 'A tracked link in a push notification has been clicked',
    },
    {
      label: 'Converted',
      value: 'push_converted',
      description: 'A person matched a conversion goal attributed to a push notification',
    },
    {
      label: 'Bounced',
      value: 'push_bounced',
      description: 'The delivery provider reported at least one invalid device token',
    },
    {
      label: 'Suppressed',
      value: 'push_dropped',
      description: "A push notification wasn't sent because at least one device token previously bounced",
    },
    {
      label: 'Failed',
      value: 'push_failed',
      description: "A push notification couldn't be sent to the delivery provider",
    },
    {
      label: 'Undeliverable',
      value: 'push_undeliverable',
      description: 'A push notification was marked as undeliverable',
    },
  ],
});
export const smsEvents = Object.freeze({
  label: 'SMS Events',
  description: 'Send all SMS events',
  items: [
    {
      label: 'Drafted',
      value: 'sms_drafted',
      description: 'An SMS draft was created',
    },
    {
      label: 'Attempted',
      value: 'sms_attempted',
      description: "An SMS that couldn't be sent to the delivery provider will be retried",
    },
    {
      label: 'Sent',
      value: 'sms_sent',
      description: 'An SMS was sent from Customer.io to the delivery provider',
    },
    {
      label: 'Delivered',
      value: 'sms_delivered',
      description: 'The delivery provider reported the SMS was delivered',
    },
    {
      label: 'Clicked',
      value: 'sms_clicked',
      description: 'A tracked link in an SMS has been clicked',
    },
    {
      label: 'Converted',
      value: 'sms_converted',
      description: 'A person matched a conversion goal attributed to an SMS',
    },
    {
      label: 'Bounced',
      value: 'sms_bounced',
      description: 'The delivery provider was unable to deliver the SMS',
    },
    {
      label: 'Failed',
      value: 'sms_failed',
      description: "An SMS couldn't be sent to the delivery provider",
    },
    {
      label: 'Undeliverable',
      value: 'sms_undeliverable',
      description: 'An SMS was marked as undeliverable',
    },
  ],
});
export const slackEvents = Object.freeze({
  label: 'Slack Events',
  description: 'Send all Slack events',
  items: [
    {
      label: 'Drafted',
      value: 'slack_drafted',
      description: 'A slack draft was created',
    },
    {
      label: 'Attempted',
      value: 'slack_attempted',
      description: "A slack message that couldn't be sent will be retried",
    },
    {
      label: 'Sent',
      value: 'slack_sent',
      description: 'A slack message was sent from Customer.io to slack',
    },
    {
      label: 'Clicked',
      value: 'slack_clicked',
      description: 'A tracked link in a slack message has been clicked',
    },
    {
      label: 'Failed',
      value: 'slack_failed',
      description: "A slack message couldn't be sent to slack",
    },
  ],
});
export const webhookEvents = Object.freeze({
  label: 'Webhook Events',
  description: 'Send all Webhook events',
  items: [
    {
      label: 'Drafted',
      value: 'webhook_drafted',
      description: 'A webhook draft was created',
    },
    {
      label: 'Attempted',
      value: 'webhook_attempted',
      description: "A webhook that couldn't be sent will be retried",
    },
    {
      label: 'Sent',
      value: 'webhook_sent',
      description: 'A webhook was sent from Customer.io to the specified Webhook URL',
    },
    {
      label: 'Clicked',
      value: 'webhook_clicked',
      description: 'A tracked link in a webhook payload has been opened',
    },
    {
      label: 'Converted',
      value: 'webhook_converted',
      description: 'A person matched a conversion goal attributed to a Webhook',
    },
    {
      label: 'Failed',
      value: 'webhook_failed',
      description: "A webhook couldn't be sent to the specified Webhook URL",
    },
    {
      label: 'Undeliverable',
      value: 'webhook_undeliverable',
      description: 'A webhook was marked as undeliverable',
    },
  ],
});

const BaseEventGroups = Object.freeze([
  customerEvents,
  emailEvents,
  inAppEvents,
  pushEvents,
  smsEvents,
  slackEvents,
  webhookEvents,
]);

const dataOutEventNames = [
  'customer_subscribed',
  'customer_unsubscribed',
  'email_drafted',
  'email_attempted',
  'email_sent',
  'email_delivered',
  'email_opened',
  'email_clicked',
  'email_converted',
  'email_unsubscribed',
  'email_bounced',
  'email_dropped',
  'email_spammed',
  'email_failed',
  'in_app_drafted',
  'in_app_attempted',
  'in_app_sent',
  'in_app_opened',
  'in_app_clicked',
  'in_app_converted',
  'in_app_failed',
  'push_drafted',
  'push_attempted',
  'push_sent',
  'push_delivered',
  'push_opened',
  'push_clicked',
  'push_converted',
  'push_bounced',
  'push_dropped',
  'push_failed',
  'sms_drafted',
  'sms_attempted',
  'sms_sent',
  'sms_delivered',
  'sms_clicked',
  'sms_converted',
  'sms_bounced',
  'sms_failed',
  'slack_drafted',
  'slack_attempted',
  'slack_sent',
  'slack_clicked',
  'slack_failed',
  'webhook_drafted',
  'webhook_attempted',
  'webhook_sent',
  'webhook_clicked',
  'webhook_converted',
  'webhook_failed',
];

// 1. Filter event groups that have at least one segmentOut/dataOut event
// 2. Filter events in those groups to include only segmentOut/dataOut events
export const DATA_OUT_EVENTS = Object.freeze(
  BaseEventGroups.filter((group) =>
    dataOutEventNames.some((eventName) => group.items.map((i) => i.value).includes(eventName)),
  ).map((group) => ({
    ...group,
    items: group.items.filter((item) => dataOutEventNames.includes(item.value)),
  })),
);

export default BaseEventGroups;
